import { Component, OnDestroy, OnInit, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MaintenanceService } from '../../services/maintenanceService';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location, NgFor, NgClass, NgIf, UpperCasePipe } from '@angular/common';

import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { ReportsService } from '../../../reports/reports.service';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';
import { MatChip } from '@angular/material/chips';
import { HierarchyDropdownComponent } from '../../../shared/elements/hierarchy-dropdown/hierarchy-dropdown.component';
import { FormsModule } from '@angular/forms';
import { DropdownWithSearchComponent } from '../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { ForecastDetailsCardComponent } from './forecast-detail-card/forecast-detail-card.component';
import { ForcastManagementTableComponent } from './forcast-management-table/forcast-management-table.component';
import { LoaderComponent } from '../../../shared/elements/loader/loader.component';
import { ForecastSegmentRelationshipComponent } from './forecast-segment-relationship/forecast-segment-relationship.component';
import { ForecastAdminManagementComponent } from './forecast-admin-management/forecast-admin-management.component';
import { BulkForecastComponent } from './bulk-forecast/bulk-forecast.component';
import { InbuiltReportV2Component } from '../../../reports/inbuilt-report-v2/inbuilt-report-v2/inbuilt-report-v2.component';
import { AppModalComponent } from '../../../shared/elements/app-modal/app-modal.component';
import { ForecastAddServicePopupComponent } from './forcast-management-table/forecast-add-service-popup/forecast-add-service-popup.component';
// Reusable owner key constants to eliminate duplication across filtering methods
const OWNER_KEYS_BASE = ['SLO_MSID', 'TechOwner_MSID', 'BusinessOwner_MSID'];
const OWNER_LEVEL_SUFFIXES = ['L4', 'L5', 'L6', 'L7', 'L8'];
const OWNER_LEADER_KEYS = OWNER_LEVEL_SUFFIXES.flatMap(level => [
  `SLO_${level}_MSID`,
  `TechOwner_${level}_MSID`,
  `BusinessOwner_${level}_MSID`
]);
const ALL_OWNER_KEYS: string[] = [...OWNER_KEYS_BASE, ...OWNER_LEADER_KEYS];
// NOTE: Delegates_MSID handled separately when chip == 'delegate'

// Utility guard helpers
function isArray<T = any>(val: any): val is T[] { return Array.isArray(val); }
function safeFlat<T = any>(arr: any[]): T[] { return arr ? (arr as any[]).flat ? (arr as any[]).flat() : ([] as T[]) : ([] as T[]); }

interface BillingSegmentItem {
  Billing_Segment: string;
  Billing_Segment_ID?: string;
  id?: string;
  name?: string;
}

interface ForecastDetails {
  Master_Billing_Segment: string;
  Billing_Segment: BillingSegmentItem[];
  id?: string;
  name?: string;
  children?: BillingSegmentItem[];
  selectedList?: string[];
}

@Component({
    selector: 'app-forecast-management',
    templateUrl: './forecast-management.component.html',
    styleUrls: ['./forecast-management.component.css'],
    animations: [
        trigger('openClose', [
            // ...
            state('open', style({
                opacity: 1,
            })),
            state('closed', style({
                opacity: 0,
            })),
            transition('open => closed', [
                animate('1s')
            ]),
            transition('closed => open', [
                animate('0.2s')
            ]),
        ]),
    ],
    imports: [RouterLink, MatTabGroup, NgFor, MatTab, NgClass, NgIf, MatIcon, MatChip, HierarchyDropdownComponent, FormsModule, DropdownWithSearchComponent, ForecastDetailsCardComponent, ForcastManagementTableComponent, LoaderComponent, ForecastSegmentRelationshipComponent, ForecastAdminManagementComponent, BulkForecastComponent, InbuiltReportV2Component, AppModalComponent, ForecastAddServicePopupComponent, UpperCasePipe],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ForecastManagementComponent implements OnInit, OnDestroy {
  public forecastDetailsMap: Map<string, string> = new Map();
  @ViewChild('addServicePopup', { static: false }) addServicePopup;
  placeholders = {
    lob: 'Select LOB',
    owner: 'Select SLO/BO/TO',
    lifecycle: 'Select App Lifecycle Status',
    services: 'Select Service',
    apps: 'Select Application'
  };
  selectedValues = {
    lob: [],
    owner: [],
    lifecycle: [],
    services: [],
    apps: []
  };
  tabs = [{ label: 'Forecast Management', value: 'forecast_management' }];
  selectedTab = 'forecast_management';
  lifeCycleData = [
    { id: 1, name: 'Production' },
    { id: 2, name: 'In Development' },
    { id: 3, name: 'Decommissioned' }
    // { id: 4, name: 'NON AIDE Specific' }
  ];
  ownersData = [];
  servicesData = [];
  appsData = [];
  filtersData = {};
  lobSublobListForDropdown: ForecastDetails[] = [];
  disableMultiSelect = false;
  hierarchyDropdownConfig = {
    parentfield: ['SegID', 'Master_Billing_Segment'],
    firstchildfield: ['Billing_Segment_ID', 'Billing_Segment'],
    secondchildfield: [],
    firstchildkey: 'Billing_Segment',
    secondchildkey: ''
  };
  originalFilterist = {
    owners: [],
    services: [],
    apps: [],
    segment: []
  };
  showLoader = false;
  disableSearch = true;
  disableReset = true;
  leaderAppOwnerSearchDisabled = true;
  lobAppMapping: any = [];
  masterSubLobList: any[] = [];

  expandAll: string = 'false';
  exportToExcel: number = 1;
  allRowsExpanded = false;
  dataSourceDetails: MatTableDataSource<any>;
  olddatasource: any;
  TABLE_COLUMNS: any;
  forecastTableData: any = [];
  expanded_columns: Array<any> = [];
  expanded_columns_charge: any = [];
  expanded_columns_vol: any = [];

  FILTERS: any = [];
  filterSegment: any;
  DATA_SCHEMA = {
    Funding_SegmentID: 'select',
    Funding_Segment: 'select',
    Funding_Owner: 'select',
    ucmg_count: 'select',
    total_acap: 'autocomplete',
    ArchitectDelegate: 'autocomplete',
    isEdit: 'isEdit'
  };

  FILTER_OPTIONS: any = {};
  TABLE_CONFIG: any = {
    expandable: true,
    pageSize: 10,
    pageIndex: 0,
    totalItems: 10,
    selection: false,
    edit: false,
    serverSidePagination: false,
    dependentFilters: {
      MasterSegment: ['Funding_SegmentID', 'Funding_Segment']
    }
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  tempFilterSegment: any;
  SearchLength = 0;
  routeParams = {};
  isForecastTableDataLoaded: boolean = false;
  masterServicesData: any = {};
  filtersLoader = false;
  disableDD: boolean;
  initialSelectedLob = [];
  initialSelectedLobString = '';
  isForecastTableUpdated: boolean = false;
  isForecastAdmin: boolean = false;
  isForecastSRM: boolean = false;
  initialCount = 0;
  forecastMapChanges: BehaviorSubject<any> = new BehaviorSubject<any>(this.initialCount);
  segmentAdmin: any;
  segment_SRM_Viewer: any;
  totalSegments: number = 0;
  isAdminOrViewer: boolean = false;
  isSegmentFAOrViewer: boolean = false;
  modalType: string = "app";
  allNewApps: any = [];
  showAddNewAppButton:boolean = true;
  showAddNewAppButtonByRole:boolean = false;
  showDropdown: boolean = false;
  forecastCycleType: any = {};
  steps: any = [
    {label: 'Update', cycle: 'Off-cycle', status: '', pillText: ''},
    {label: 'Attest', cycle: 'In-cycle', status: '', pillText: ''},
    {label: 'Cycle Closed', cycle: 'Closed-cycle', status: '', pillText: ''}
  ];

  isChipClicked: boolean = false;
  clickedChip: string;
  subject = new Subject<string>();
  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  leaderSearch = '';
  showLeaderList = false;
  showLeaderListLoader = false;
  leaderList = [];
  selectedOwnerType: string[] = [];
  tabList = ['billing_segment', 'owners', 'delegate'];
  selectedTabIndex = 0;
  selectedOption = 'billing_segment';
  selectedList: any;
  allsegmetList: any[];
  selectedApplication = [];
  resetTrigger: number = 0;
  searchedSelectedList: any;

  private compareAlphabetically(a: string, b: string): number {
    return (a || '').localeCompare((b || ''), undefined, { sensitivity: 'base' });
  }

  constructor(
    public maintenanceService: MaintenanceService,
    private route: Router,
    private toaster: ToastrService,
    private activatedRoute: ActivatedRoute,
    public location: Location,
    private sharedAuthService: SharedAuthService,
    private reportsService: ReportsService
  ) { }

  ngOnDestroy(): void {
    try {
      // Unsubscribe from forecastMapChanges
      if (this.forecastMapChanges) {
        this.forecastMapChanges.unsubscribe();
      }

      // Complete destroy$ to clean up ReplaySubject
      this.destroy$.next(true);
      this.destroy$.complete();

      // Clear cached data
      this.maintenanceService.deleteCachedData('getForecastRoleManagementData');
      this.maintenanceService.deleteCachedData('isAdminDashboardUpdated');
      this.maintenanceService.setForecastDropdownData([]);
      // Remove local storage items
      if (sessionStorage.getItem('forecastCycleMsg')) {
        sessionStorage.removeItem('forecastCycleMsg');
      }
    } catch (error) {
      console.error('Error during cleanup:', error);
    }
  }



  ngOnInit() {

    this.activatedRoute.url.subscribe((url) => {
      if (!url.toString().includes('search')) {
        this.isChipClicked = true;
        this.clickedChip = 'billing_segment';
      }
      this.disableReset = false;
    });



    this.isForecastTableDataLoaded = false;
    this.getForecastFilters();
    this.getServiceAndAccessDetails();
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.getForecastOwnerDetails();
      });
    } else {
        this.getForecastOwnerDetails();
    }
    this.forecastMapChanges.subscribe(res => {
      if (res >= 3) {
        this.setTableColumn();
        if (this.masterServicesData.forecastData && this.masterServicesData.forecastData.length > 0) {
          const getCurrentForecastData: Array<any> = this.masterServicesData.forecastData.filter(item => item.Previous.toLowerCase() == 'no');
          if (getCurrentForecastData.length > 0) {
            this.getForeCastCycleType(getCurrentForecastData[0]);
          }
        }
      }
    });

    this.getNewApplication();
    this.loadInbuiltReports();

    const currentUrl = this.route.url;

    if (currentUrl.includes('search')) {
      this.showAddNewAppButton = false;
    }
  }

  private loadInbuiltReports(): void {
    const queryParams = {
      isEmbed: true,
      Page_name: 'Forecast Management',
      Report_Type: 'inBuilt'
    };

    this.reportsService.getReportDetails(queryParams).subscribe({
      next: (response: any) => {
        console.log(response, 'response');
      if(response && response.length > 0){
          response.forEach((element: any) => {
            const key = element.Report;
            this.tabs.push({ label: key, value: key });
          });
      }
      },
      error: (error: any) => {
        console.error('Error loading reports:', error);
      }
    });
  }

  searchLeader(event, searchKeys: string[]) {
    const searchValue = event.target.value.trim().toLowerCase();
    if (searchValue.length >= 3) {
      this.showLeaderListLoader = true;
      this.showLeaderList = true;

      // Define key mappings for SLO, BO, and TO
      const keyMappings = {
        SLO: ['Service_Level_Owner', 'SLO_L4_Name', 'SLO_L5_Name', 'SLO_L6_Name', 'SLO_L7_Name', 'SLO_L8_Name'],
        BO: ['Business_Owner', 'BusinessOwner_L4_Name', 'BusinessOwner_L5_Name', 'BusinessOwner_L6_Name', 'BusinessOwner_L7_Name', 'BusinessOwner_L8_Name'],
        TO: ['Technical_Owner', 'TechOwner_L4_Name', 'TechOwner_L5_Name', 'TechOwner_L6_Name', 'TechOwner_L7_Name', 'TechOwner_L8_Name']
      };

      // Collect all keys to search based on the provided searchKeys array
      const keysToSearch = searchKeys.flatMap(key => keyMappings[key] || []);

      // Filter filtersData based on the search value
      const allMatches = this.filtersData['appDetails']?.flatMap(item => {
        // Dynamically match keys based on keysToSearch
        const dynamicMatches = keysToSearch.map(key => {
          const value = item[key];
          if (value?.toLowerCase().includes(searchValue)) {
            return {
              name: value,
              id: this.getMSIDFromDataItem(value, item, key),
              isOwner: ['Service_Level_Owner', 'Business_Owner', 'Technical_Owner'].includes(key),
              isLeader: ['TechOwner_L4_Name', 'SLO_L4_Name', 'TechOwner_L5_Name', 'SLO_L5_Name', 'SLO_L6_Name', 'TechOwner_L6_Name', 'TechOwner_L7_Name', 'BusinessOwner_L4_Name', 'SLO_L8_Name', 'SLO_L5_Name', 'TechOwner_L8_Name', 'BusinessOwner_L5_Name', 'BusinessOwner_L6_Name', 'SLO_L6_Name', 'SLO_L7_Name', 'BusinessOwner_L8_Name', 'BusinessOwner_L7_Name'].includes(key)
            };
          }
          return null;
        }).filter(Boolean); // Remove null values

        return dynamicMatches;
      });

      // Merge duplicates and ensure both isOwner and isLeader are true if applicable
      const mergedMatches = new Map();
      allMatches.forEach(match => {
        const existing = mergedMatches.get(match.name.toLowerCase());
        if (existing) {
          existing.isOwner = existing.isOwner || match.isOwner;
          existing.isLeader = existing.isLeader || match.isLeader;
        } else {
          mergedMatches.set(match.name.toLowerCase(), match);
        }
      });

      this.leaderList = Array.from(mergedMatches.values());

      this.showLeaderListLoader = false; // Stop the loader after filtering
    } else {
      this.showLeaderList = false;
      this.leaderList = [];
    }
  }

  getOwnerId(item: any): string | null {
    return item['BO_L4_MSID'] || item['BO_L5_MSID'] || item['BO_L6_MSID'] || item['BO_L7_MSID'] || item['BO_L8_MSID'] ||
      item['SLO_MSID'] || item['SLO_L4_MSID'] || item['SLO_L5_MSID'] || item['SLO_L6_MSID'] || item['SLO_L7_MSID'] || item['SLO_L8_MSID'] ||
      item['TechOwner_MSID'] || item['TO_L4_MSID'] || item['TO_L5_MSID'] || item['TO_L6_MSID'] || item['TO_L7_MSID'] || item['TO_L8_MSID'] ||
      item['BusinessOwner_MSID'] || null;
  }

  searchDelegates(event: Event) {
    const searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (searchValue.length >= 3) {
      this.showLeaderListLoader = true;
      this.showLeaderList = true;

      const allMatches = this.getDelegateMatches(searchValue);
      this.leaderList = this.getUniqueMatches(allMatches);

      this.showLeaderListLoader = false;
    } else {
      this.showLeaderList = false;
      this.leaderList = [];
    }
  }

  getDelegateMatches(searchValue: string): any[] {
    return this.filtersData['appDetails']?.flatMap(item => {
      const delegates = item['Delegates'];
      const delegatesMSIDs = item['Delegates_MSID'];

      if (delegates && delegatesMSIDs) {
        const delegateNames = this.splitDelegateNames(delegates);
        const delegateMSIDsList = delegatesMSIDs.split(',').map(msid => msid.trim());

        return delegateNames
          .map((name, index) => {
            if (name.toLowerCase().includes(searchValue)) {
              return {
                name: name,
                id: delegateMSIDsList[index] || null,
                isDelegate: true
              };
            }
            return null;
          })
          .filter(Boolean);
      }
      return [];
    }) || [];
  }

  splitDelegateNames(delegates: string): string[] {
    const delegateNames = [];
    const delegateParts = delegates.split(',');
    for (let i = 0; i < delegateParts.length; i += 2) {
      const fullName = `${delegateParts[i].trim()}, ${delegateParts[i + 1]?.trim() || ''}`;
      delegateNames.push(fullName);
    }
    return delegateNames;
  }

  getUniqueMatches(matches: any[]): any[] {
    return Array.from(
      new Map(matches.map(item => [item.name.toLowerCase(), item])).values()
    );
  }

  onOwnerTypeClick(event: Event, value: string): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      // Add the value if it's not already in the array
      if (!this.selectedOwnerType.includes(value)) {
        this.selectedOwnerType.push(value);
      }
    } else {
      // Remove the value if it exists in the array
      this.selectedOwnerType = this.selectedOwnerType.filter((item) => item !== value);
    }
    this.isChipClicked = true;
    this.clickedChip = 'owners';
    this.reset();
    this.location.go(this.location.path().split('search')[0]);
  }


  selectAllOptions(event: MouseEvent, groupName: string): void {
    // Prevent the event from triggering when clicking directly on checkboxes
    if ((event.target as HTMLElement).tagName === 'INPUT') {
      return;
    }

    // Select all checkboxes with the specified name
    const checkboxes = document.getElementsByName(groupName) as NodeListOf<HTMLInputElement>;
    checkboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });
    this.isChipClicked = true;
    this.clickedChip = 'owners';
    this.selectedOwnerType = ['SLO', 'BO', 'TO'];
    this.reset();
    this.location.go(this.location.path().split('search')[0]);
  }


  onChipClick(chipName: string): void {
    this.isChipClicked = true;
    this.clickedChip = chipName;
    this.selectedOwnerType = [];
    this.reset()
    this.location.go(this.location.path().split('search')[0]);

    // Uncheck all radio buttons of the "owner" chip if another chip is clicked
    if (chipName !== 'owners') {
      const ownerCheckboxes = document.getElementsByName('chip2-options') as NodeListOf<HTMLInputElement>;
      ownerCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });

      // Clear the selectedOwnerType array
      this.selectedOwnerType = [];
    }
  }
  tabChangeClick(event) {
    if (this.tabs && this.tabs[event.index]) {
      this.selectedTab = this.tabs[event.index].value;
      if (this.selectedTab === 'forecast_management') {
        this.onToggleChange(true);
        const isAdminDashboardUpdated = this.maintenanceService.getIsAdminDashboardUpdated();
        if (isAdminDashboardUpdated) {
          this.refreshData();
        }
      }
    } else {
      console.error('Invalid tab index or tabs array is not initialized.');
    }

    // if(!this.isForecastTableDataLoaded){
    //   this.reset(); //if this runs then reset is disabled
    // }
  }

   getForecastDetails() {
     this.activatedRoute.queryParams.subscribe(data => {
       try {
         // Decode the URL-encoded filters string, then parse JSON
         const filters = data['filters'];
         if (filters) {
           const decodedString = decodeURIComponent(filters);
           this.routeParams = JSON.parse(decodedString);
         } else {
           this.routeParams = [];
         }
       } catch (e) {
         console.warn('Failed to parse filters query param:', data['filters'], e);
       }
       const payload = this.buildPayloadFromRouteParams();

       if (Object.keys(payload).length > 0) {
         this.getForecastDetailsAPI(payload);
         this.disableReset = false;
       } else if (this.routeParams['selectAll'] && JSON.parse(this.routeParams['selectAll']) == 1) {
         this.getForecastDetailsAPI({});
       }
     });
   }

  private buildPayloadFromRouteParams(): any {
    const payload = {};
    // Helper function to safely decode and parse URL-encoded JSON values
    const decodeAndParse = (value: string) => {
        try {
            const decoded = decodeURIComponent(value);
            return JSON.parse(decoded);
        } catch (error) {
            // If decoding fails, try parsing the original value
            try {
                return JSON.parse(value);
            } catch (fallbackError) {
                console.warn('Failed to parse route parameter:', value, fallbackError);
                return value; // Return original value if all parsing fails
            }
        }
    };

    if (this.routeParams['Billing_Segment']) {
        payload['Billing_Segment'] = decodeAndParse(this.routeParams['Billing_Segment']);
    }
    ['leaderSLOId', 'leaderBOId', 'leaderTOId', 'ownerSLOId', 'ownerBOId', 'ownerTOId', 'delegateId'].forEach(key => {
        if (this.routeParams[key]) {
            payload[key] = decodeAndParse(this.routeParams[key]);
        }
    });
    if (this.routeParams['sv_desc']) {
        payload['sv_desc'] = decodeAndParse(this.routeParams['sv_desc']);
    }
    if (this.routeParams['ask_global_id']) {
        payload['ask_global_id'] = decodeAndParse(this.routeParams['ask_global_id']);
    }
    if (this.routeParams['App Lifecycle_Status']) {
        payload['App Lifecycle_Status'] = decodeAndParse(this.routeParams['App Lifecycle_Status']);
    }

    return payload;
  }
  populateSelectedValues() {
    if (!this.routeParams) {
      this.resetSelectedValues();
      return;
    }

    const { owners, sv_desc, ask_global_id, lifecycle, billingSegments } = this.extractRouteParams();

    if (lifecycle) {
      this.populateLifecycleValues(lifecycle);
    }

    if (billingSegments) {
      this.initialSelectedLob = this.getSelectedListfromURL();
      this.transformInitialSelectedLobToSet();
      this.filterOwners(billingSegments, []);
    }

    if (this.filtersData['appDetails'] && this.filtersData['appDetails'].length > 0) {
      this.populateAppDetails(owners, sv_desc, ask_global_id);
    }
  }

  private resetSelectedValues() {
    this.selectedValues = {
      lob: [],
      owner: [],
      lifecycle: this.lifeCycleData,
      services: [],
      apps: [],
    };
  }

  private getSelectedListfromURL() {
    let list = this.routeParams['selectedList'] ? JSON.parse(this.routeParams['selectedList']) : [];
    return list;
  }

  private extractRouteParams() {
    return {
      owners: this.routeParams['ownerId'] ? JSON.parse(this.routeParams['ownerId']) : [],
      sv_desc: this.routeParams['sv_desc'] ? JSON.parse(this.routeParams['sv_desc']) : [],
      ask_global_id: this.routeParams['ask_global_id'] ? JSON.parse(this.routeParams['ask_global_id']) : [],
      lifecycle: this.routeParams['App Lifecycle_Status'] ? JSON.parse(this.routeParams['App Lifecycle_Status']) : [],
      billingSegments: this.routeParams['Billing_Segment'] ? JSON.parse(this.routeParams['Billing_Segment']) : [],
    };
  }

  private populateLifecycleValues(lifecycle: any[]) {
    this.selectedValues['lifecycle'] = lifecycle.map(row => {
      const lifecycleItem = this.lifeCycleData.find(lifeCycle => lifeCycle.name === row);
      return lifecycleItem ? { id: lifecycleItem.id, name: row } : null;
    }).filter(Boolean);
  }

  private populateAppDetails(owners: any[], sv_desc: any[], ask_global_id: any[]) {
    this.filtersData['appDetails'].forEach(row => {
      this.addOwnerDetails(row, owners);
      this.addServiceDetails(row, sv_desc);
      this.addAppDetails(row, ask_global_id);
    });
  }

  private addOwnerDetails(row: any, owners: any[]) {
    if (owners) {
      this.addUniqueOwner(row, owners, 'SLO_MSID', 'Service_Level_Owner');
      this.addUniqueOwner(row, owners, 'TechOwner_MSID', 'Technical_Owner');
      this.addUniqueOwner(row, owners, 'BusinessOwner_MSID', 'Business_Owner');
    }
  }

  private addUniqueOwner(row: any, owners: any[], msidKey: string, nameKey: string) {
    if (owners.includes(row[msidKey]) && this.selectedValues['owner'].findIndex(owner => owner.id === row[msidKey]) < 0) {
      this.selectedValues['owner'].push({ id: row[msidKey], name: row[nameKey] });
    }
  }

  private addServiceDetails(row: any, sv_desc: any[]) {
    if (sv_desc && sv_desc.includes(row.sv_desc) && this.selectedValues['services'].findIndex(service => service.name === row.sv_desc) < 0) {
      this.selectedValues['services'].push({ id: row.service, name: row.sv_desc });
    }
  }

  private addAppDetails(row: any, ask_global_id: any[]) {
    if (ask_global_id && ask_global_id.includes(row.ask_global_id) && this.selectedValues['apps'].findIndex(app => app.id === row.ask_global_id) < 0) {
      this.selectedValues['apps'].push({
        id: row.ask_global_id,
        name: row.app_name ? `${row.ask_global_id} ${row.app_name}` : row.ask_global_id
      });
    }
  }

  filterOutNonAide(result: any[], type: string): any[] {
    if (!result || !Array.isArray(result)) {
      return []; // Return an empty array if result is null, undefined, or not an array
    }
    if (type == 'seg') {
      return result.filter(row =>
        row['app_lifecycle_status'] !== 'NON AIDE Specific' ||
         (row['app_lifecycle_status'] === 'NON AIDE Specific' && this.segmentAdmin.includes(row['Master_Billing_Segment'])) ||
        (row['app_lifecycle_status'] === 'NON AIDE Specific' && this.segment_SRM_Viewer.includes(row['Master_Billing_Segment']))
      );
    } else if (type == 'all') {
      return result.filter(row => row['app_lifecycle_status'] !== 'NON AIDE Specific');
    }

  }
  getForecastDetailsAPI(payload) {
    this.showLoader = true;
    this.isForecastTableUpdated = false;

    const payloadKeys = Object.keys(payload);
    this.addLifecycleStatusToPayload(payload, payloadKeys);

    this.maintenanceService.getForecastDetails(payload).subscribe(
      result => {
        if (result) {
          result = this.filterResultBasedOnRoles(result);
          this.processForecastDetails(result);
        }
        this.finalizeForecastDetails(result);
      },
      () => {
        this.showLoader = false;
        this.handleForecastDetailsError();
      }
    );
  }

  addLifecycleStatusToPayload(payload, payloadKeys) {
    if (payloadKeys.length > 0 && payloadKeys.includes('App Lifecycle_Status')) {
      return;
    }

    if (this.isAdminOrViewer || this.isSegmentFAOrViewer) {
      payload['App Lifecycle_Status'] = this.lifeCycleData.map(lif => lif.name);
    }
  }

  filterResultBasedOnRoles(result) {
    if (!this.isAdminOrViewer && this.isSegmentFAOrViewer) {
      const filteredResult = this.filterOutNonAide(result, 'seg');
      return filteredResult;
    } else if (!this.isAdminOrViewer && !this.isSegmentFAOrViewer) {
      return this.filterOutNonAide(result, 'all');
    }
    return result;
  }

  processForecastDetails(result) {
    this.getAgrregatedForecastDetails(result);
    this.forecastTableData = result;
    this.filterSegment = result;
    this.tempFilterSegment = result;
    this.TABLE_CONFIG['TABLE_CLASS'] = 'lob-maintenance-tble-container';
    this.TABLE_CONFIG['FILTER_OPTIONS'] = JSON.parse(JSON.stringify(this.FILTER_OPTIONS));
    this.olddatasource = result;
    this.dataSourceDetails = new MatTableDataSource(result);
  }

  finalizeForecastDetails(result) {
    this.showLoader = false;
    this.SearchLength = 1;
    this.forecastMapChanges.next(this.initialCount++);
    this.isForecastTableDataLoaded = true;
    this.isForecastTableUpdated = true;
  }

  handleForecastDetailsError() {
    this.showLoader = false;
    this.toaster.error('Error While Fetching Data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }
  getAgrregatedForecastDetails(val) {
    // Aggregation configuration: source field -> target summary key
    const AGG_CONFIG: { source: string; target: string }[] = [
      { source: 'Prev_FY_Total', sourceAlt: 'Prev_FY_Total', target: 'totalPrevYearFYCharges' },
      { source: 'Current_Projections_Total', sourceAlt: 'Current_Projections_Total', target: 'totalInfraProjectedCharges' },
      { source: 'Curr_Year_FC_Prev_Charges_Total', sourceAlt: 'Curr_Year_FC_Prev_Charges_Total', target: 'totalCurrYearFCPrevCharges' },
      { source: 'Curr_Year_FC_Curr_Charges_Total', sourceAlt: 'Curr_Year_FC_Curr_Charges_Total', target: 'totalCurrYearFCCurrCharges' },
      { source: 'Future_Year_FC_Prev_Charges_Total', sourceAlt: 'Future_Year_FC_Prev_Charges_Total', target: 'totalFutureYearFCPrevCharges' },
      { source: 'Future_Year_FC_Curr_Charges_Total', sourceAlt: 'Future_Year_FC_Curr_Charges_Total', target: 'totalFutureYearFCCurrCharges' }
    ] as any;

    // Initialise totals
    AGG_CONFIG.forEach(cfg => (val[cfg.target] = 0));

    (val || []).forEach((row: any) => {
      AGG_CONFIG.forEach(cfg => {
        const numberVal = row[cfg.source];
        if (numberVal != null) {
          val[cfg.target] += numberVal;
        }
      });
    });

    this.updateForecastDetailsMap(val);
  }

  updateForecastDetailsMap(val) {
    // Correct mapping (previous code swapped two keys inadvertently)
    this.forecastDetailsMap.set('totalPrevYearFYCharges', (val.totalPrevYearFYCharges || 0).toString());
    this.forecastDetailsMap.set('totalInfraProjectedCharges', (val.totalInfraProjectedCharges || 0).toString());
    this.forecastDetailsMap.set('totalCurrYearFCPrevCharges', (val.totalCurrYearFCPrevCharges || 0).toString());
    this.forecastDetailsMap.set('totalCurrYearFCCurrCharges', (val.totalCurrYearFCCurrCharges || 0).toString());
    this.forecastDetailsMap.set('totalFutureYearFCPrevCharges', (val.totalFutureYearFCPrevCharges || 0).toString());
    this.forecastDetailsMap.set('totalFutureYearFCCurrCharges', (val.totalFutureYearFCCurrCharges || 0).toString());
  }
delegatesData = [];

  private processInitialFilterData(data: any): void {
    this.leaderAppOwnerSearchDisabled = false;
    const parseddata = JSON.parse(JSON.stringify(data));

    if (this.isAdminOrViewer) {
      this.filtersData = parseddata;
    } else if (this.isSegmentFAOrViewer) {
      this.filtersData['appDetails'] = this.excludeNonAideApp(parseddata, 'SFA');
    } else {
      this.filtersData['appDetails'] = this.excludeNonAideApp(parseddata, 'NSFA');
    }
  }
  transformBillingSegmentData(data: any[]): any[] {
    return data.map(row => {
      const transformedRow = { ...row };
      transformedRow.id = transformedRow.Master_Billing_Segment;
      transformedRow.name = transformedRow.Master_Billing_Segment;
      transformedRow.children = transformedRow.Billing_Segment.map(subrow => ({
        ...subrow,
        id: `${subrow.Billing_Segment}-L2`,
        name: subrow.Billing_Segment_ID
      }));
      return transformedRow;
    });
  }
  private populateDropdownData(): void {
    const data = this.populateFiltersSet();
    const lobSublobListForDropdown = [...data['billingSegmentSet']];

    this.lobSublobListForDropdown = this.sortSegmentData(lobSublobListForDropdown);
    this.allsegmetList = this.lobSublobListForDropdown.flatMap(row =>
      row.Billing_Segment.map(subrow => row.Master_Billing_Segment + '-' + subrow.Billing_Segment)
    );
    this.lobSublobListForDropdown = this.transformBillingSegmentData(this.lobSublobListForDropdown);

    this.ownersData = [...data['ownersSet']].map(owner => JSON.parse(owner));
    this.delegatesData = [...data['delegatesSet']].map(delegate => JSON.parse(delegate));
    this.servicesData = [...data['servicesSet']].map(service => JSON.parse(service));
    this.servicesData = this.sortServiceData();
    this.appsData = [...data['appsSet']].map(app => JSON.parse(app));
    this.deduplicateServicesData();
  }

  private deduplicateServicesData(): void {
    const services = new Set<any>();
    this.servicesData.forEach(row => {
      services.add(row.name);
    });

    this.servicesData = this.servicesData.filter(row => {
      if (services.has(row.name)) {
        services.delete(row.name);
        return true;
      }
      return false;
    });
  }

  private processConditionalFilters(): void {
    if ((this.selectedValues['owner'] ?? []).length > 0) {
      this.processOwnerFilters();
    }

    if ((this.selectedValues['services'] ?? []).length > 0) {
      this.processServiceFilters();
    }

    if (this.routeParams['selectAll'] && JSON.parse(this.routeParams['selectAll']) == 1) {
      this.processSelectAllFilters();
    }
  }

  private processOwnerFilters(): void {
    const { servicesSet, appsSet } = this.filterServices();
    this.servicesData = [...servicesSet].map(service => JSON.parse(service));
    this.servicesData = this.sortServiceData();
    this.appsData = [...appsSet].map(app => JSON.parse(app));
    this.deduplicateServicesData();
  }

  private processServiceFilters(): void {
    const appsSet = this.filterApps(true);
    this.appsData = [...appsSet].map(app => JSON.parse(app));
  }

  private processSelectAllFilters(): void {
    this.disableReset = false;
    this.selectedValues['services'] = this.servicesData;
    this.selectedValues['apps'] = this.appsData;
    this.selectedValues['owner'] = this.ownersData;
    this.initialSelectedLob = this.allsegmetList;
    this.transformInitialSelectedLobToSet();
  }

  private setupOriginalFilterLists(): void {
    this.originalFilterist = {
      owners: JSON.parse(JSON.stringify(this.ownersData)),
      services: JSON.parse(JSON.stringify(this.servicesData)),
      apps: JSON.parse(JSON.stringify(this.appsData)),
      segment: JSON.parse(JSON.stringify(this.lobSublobListForDropdown))
    };
    this.selectedValues['lifecycle'] = this.lifeCycleData;
  }

  private processSegmentRouteParams(segmentAdmin: any): void {
    const masterSegments = this.lobSublobListForDropdown.filter(row =>
      row.Master_Billing_Segment == segmentAdmin
    );

    const masterSegmentSelectedList = this.lobSublobListForDropdown.flatMap(row =>
      row.Billing_Segment.map(subrow => row.Master_Billing_Segment + '-' + subrow.Billing_Segment)
    );

    this.initialSelectedLob = masterSegmentSelectedList;
    this.transformInitialSelectedLobToSet();
    const billing_segment = masterSegments.map(row => row.Billing_Segment)
      .flat().map(lob => lob.Billing_Segment);

    this.getForecastDetailsAPI({ Billing_Segment: billing_segment });
    this.selectedValues['lob'] = masterSegments;

      const queryParams = {
        'Billing_Segment': JSON.stringify(billing_segment),
        'selectedList': JSON.stringify(masterSegmentSelectedList)
      };
      const filters = JSON.stringify(queryParams);
      const encodedFilters = encodeURIComponent(filters);
      this.route.navigate(['/maintenanceV4/forecast-management/search'], {
        queryParams: { filters: encodedFilters },
        queryParamsHandling: 'merge'
      });
  }

   private processRouteParameters(): void {
     this.activatedRoute.queryParams.subscribe(data => {
       try{
           // Decode the URL-encoded filters string, then parse JSON
           const filters = data['filters'];
           if (filters) {
             const decodedString = decodeURIComponent(filters);
             this.routeParams = JSON.parse(decodedString);
           } else {
             this.routeParams = [];
           }
       } catch (e) {
         console.warn('Failed to parse filters query param:', data['filters'], e);
       }

       if (this.routeParams['serviceOwner'] && JSON.parse(this.routeParams['serviceOwner']) == 1) {
         this.getServiceOwnerAppDetails();
       }

       if (this.routeParams['segment']) {
         const segmentAdmin = JSON.parse(this.routeParams['segment']);
         this.processSegmentRouteParams(segmentAdmin);
       }

       this.isChipClicked = true;
       this.clickedChip = this.routeParams['selectedTab'] ? this.routeParams['selectedTab'] : 'billing_segment';

       if (this.routeParams['leaderSearch'] && this.routeParams['leaderSearch'] != '') {
         this.leaderSearch = this.routeParams['leaderSearch'];
       }

       if (this.routeParams['selectedOwnerType'] && this.routeParams['selectedOwnerType'] != '') {
         this.selectedOwnerType = JSON.parse(this.routeParams['selectedOwnerType']);
       }

       this.parseUrlFilters(this.route.url);
    });
  }

  private handleFilterProcessingCompletion(): void {
    this.filtersLoader = false;
    this.disableDD = false;
    this.processConditionalFilters();
  }

  getForecastFilters() {
    this.filtersLoader = true;
    this.maintenanceService.getForecastFilters().subscribe(
      async data => {
        this.processInitialFilterData(data);
        this.lobSublobListForDropdown = [];

        const promise = new Promise((resolve) => {
          this.populateDropdownData();
          resolve(null);
        });

        promise.then(() => {
          setTimeout(() => {
            this.handleFilterProcessingCompletion();
          }, 1000);
        });

        this.setupOriginalFilterLists();
        this.processRouteParameters();
      },
      () => {
        this.filtersLoader = false;
        this.toaster.error('Error While Fetching Filters', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }
  transformInitialSelectedLobToSet(){
    const selectedList:any = [];
    if(this.initialSelectedLob && this.initialSelectedLob.length > 0){
      this.initialSelectedLob.forEach(item => {
          const itemParts = item.split('-');
          const masterSegment = itemParts[0];
          const billingSegment = itemParts.slice(1).join('-');
        selectedList.push({ L1: masterSegment, L2: `${billingSegment}-L2` });
      });
      this.initialSelectedLobString = JSON.stringify(selectedList);
    } else {
      this.initialSelectedLobString = '';
    }
  }
  /**
 * Parses filter parameters from the current URL and updates selected values.
 */
   private parseUrlFilters(currentUrl: string): void {
     if (!currentUrl.includes('search')) {
       return;
     }
     this.showAddNewAppButton = false;
     try {
      const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
      const filters = urlParams.get('filters');
       if (filters) {
        const decodedFilters = JSON.parse(decodeURIComponent(filters));
         if (typeof decodedFilters === 'object' && decodedFilters !== null) {
           let sv_desc_list: string[] = Array.isArray(decodedFilters.sv_desc) ? decodedFilters.sv_desc : (decodedFilters.sv_desc ? JSON.parse(decodedFilters.sv_desc) : []);
           let ask_global_id: string[] = Array.isArray(decodedFilters.ask_global_id) ? decodedFilters.ask_global_id : (decodedFilters.ask_global_id ? JSON.parse(decodedFilters.ask_global_id) : []);
           this.initialSelectedLob = decodedFilters.selectedList ? JSON.parse(decodedFilters.selectedList) : [];
           // Use Set for faster lookups if data is large
           this.transformInitialSelectedLobToSet();
           const svDescSet = new Set(sv_desc_list);
           const askGlobalIdSet = new Set(ask_global_id);
           this.selectedValues['services'] = this.servicesData.filter(item => svDescSet.has(item.name));
           this.selectedValues['apps'] = this.appsData.filter(item => askGlobalIdSet.has(item.id));
           this.selectedValues['lob'] = this.initialSelectedLob;
         } else {
           console.warn('Decoded filters is not an object:', decodedFilters);
         }
       }
     } catch (error) {
       console.error('Failed to parse filters from URL:', error);
       // Optionally, show user feedback here
     }
   }


  excludeNonAideApp(appList: any, type: any): any[] {
    let filteredApp = [];
    if (appList && appList['appDetails']) {
      if (type == 'SFA') {
        filteredApp = appList['appDetails']?.filter(row => row['App Lifecycle_Status'] != "NON AIDE Specific" || (row['App Lifecycle_Status'] == "NON AIDE Specific" && ( this.segmentAdmin.includes(row['Master_Billing_Segment']) || this.segment_SRM_Viewer.includes(row['Master_Billing_Segment']))));
      } else {
        filteredApp = appList['appDetails']?.filter(row => row['App Lifecycle_Status'] != "NON AIDE Specific");
      }
    } else {
      filteredApp = [];
    }

    return filteredApp;
  }
  getServiceOwnerAppDetails() {
    let serviceList = [];
    const msid = this.sharedAuthService.getMsid(); // Retrieve the current user's msid

      // Check if masterServicesData is null or undefined
      if (!this.masterServicesData) {
        this.selectedValues.services = [];
        const queryParams = { sv_desc: [] };
        const filters = JSON.stringify(queryParams);
        const encodedFilters = encodeURIComponent(filters);
        this.route.navigate(['/maintenanceV4/forecast-management/search'], {
          queryParams: { filters: encodedFilters },
          queryParamsHandling: 'merge'
        });
        return;
      }

    // Filter domestic services
    if (this.masterServicesData.domestic) {
      this.masterServicesData.domestic.forEach(service => {
        if (service.Service_Owner_msid === msid) {
          serviceList.push({ name: service.Service_Name, msid: service.Service_Owner_msid });
        }
      });
    }

    // Filter international services
    if (this.masterServicesData.international) {
      this.masterServicesData.international.forEach(service => {
        if (service.Service_Owner_msid === msid) {
          serviceList.push({ name: service.Service_Name, msid: service.Service_Owner_msid });
        }
      });
    }

       // Assign filtered services to selectedValues.services
     this.selectedValues.services = serviceList;

     // Prepare payload and update the browser URL
     const uniqueServiceNames = Array.from(new Set(serviceList.map(service => service.name))); // Ensure unique names
     const payload = { sv_desc: uniqueServiceNames };

     // Call the API with the payload
     this.getForecastDetailsAPI(payload);

      // Update the browser URL
      const queryParams = { sv_desc: uniqueServiceNames };
      const filters = JSON.stringify(queryParams);
      const encodedFilters = encodeURIComponent(filters);
      this.route.navigate(['/maintenanceV4/forecast-management/search'], {
        queryParams: { filters: encodedFilters },
        queryParamsHandling: 'merge'
      });
  }


  populateFiltersSet() {

    const servicesSet = new Set<any>();
    const appsSet = new Set<any>();
    const billingSegmentSet = [];
    const delegatesSet = new Set<any>();
    const ownersSet = new Set<any>();



    this.filtersData['appDetails'].forEach(row => {
      if (row.SLO_MSID) {
        ownersSet.add(
          JSON.stringify({
            id: row.SLO_MSID,
            name: row.Service_Level_Owner
          })
        );
      }
      if (row.Master_Billing_Segment) {
        row.Billing_Segment = row.Billing_Segment ? row.Billing_Segment : 'No Mapping';
        const existingMasterIndex = billingSegmentSet.findIndex(each => each.Master_Billing_Segment == row.Master_Billing_Segment);
        if (existingMasterIndex >= 0) {
          billingSegmentSet[existingMasterIndex].Billing_Segment.findIndex(each => each.Billing_Segment == row.Billing_Segment) < 0 ? billingSegmentSet[existingMasterIndex].Billing_Segment.push({ Billing_Segment: row.Billing_Segment, Billing_Segment_ID: row.Billing_Segment }) : null;
        } else {
          const obj = {
            'Master_Billing_Segment': row.Master_Billing_Segment,
            'Billing_Segment': [{ Billing_Segment: row.Billing_Segment, Billing_Segment_ID: row.Billing_Segment }]
          };
          billingSegmentSet.push(obj);
        }

      }
      billingSegmentSet.forEach(row => {
        this.totalSegments += row.Billing_Segment.length;
      })

      if (row.Delegates_MSID && row.Delegates_MSID !== '') {
        const delegateNamesArray = row.Delegates ? row.Delegates.split(',') : [];
        const delegateNames = [];
        for (let i = 0; i < delegateNamesArray.length; i += 2) {
          delegateNames.push(`${delegateNamesArray[i].trim()}, ${delegateNamesArray[i + 1]?.trim() || ''}`);
        }

        const delegateMSIDs = row.Delegates_MSID.split(',').map(msid => msid.trim());

        // Map the data into an array of objects
        const delegateArray = delegateMSIDs.map((msid, index) => ({
          id: msid,
          name: delegateNames[index] || '' // Handle cases where names and MSIDs don't match in length
        }));

        // Add each delegate to the delegatesSet
        delegateArray.forEach(delegate => {
          delegatesSet.add(JSON.stringify(delegate));
        });
      }
      servicesSet.add(
        JSON.stringify({
          id: row.service,
          name: row.sv_desc
        })
      );
      appsSet.add(
        JSON.stringify({
          id: row.ask_global_id,
          name: row.app_name ? row.ask_global_id + ' ' + row.app_name : row.ask_global_id
        })
      );
    });
    return { ownersSet: ownersSet, servicesSet: servicesSet, appsSet: appsSet, billingSegmentSet: billingSegmentSet, delegatesSet: delegatesSet };
  }
  setSelectedAllBs(event) {
    const result = [];
    const globalSelectedList = new Set<string>();
    const excludePaths = event[0].__excludePaths || [];
    this.lobSublobListForDropdown.forEach(masterSegment => {
      masterSegment?.children.forEach(child => {
        const billingSegmentName = child.Billing_Segment || child.name;
        const isExcluded = excludePaths.some(excludePath =>
          excludePath.L1 === masterSegment.id && excludePath.L2 === billingSegmentName
        );
        if (isExcluded) {
          return;
        }
        globalSelectedList.add(`${masterSegment.id}-${billingSegmentName}`);
      });
    });

    // Iterate through lobSublobListForDropdown to build the result
    this.lobSublobListForDropdown.forEach(masterSegment => {
      const billingSegments = new Set<string>();

      // Iterate through children (billing segments) and add to selectedList
      if (masterSegment.children && Array.isArray(masterSegment.children)) {
        masterSegment.children.forEach(child => {
          // Get the actual billing segment name (Billing_Segment property from the original data)
          const billingSegmentName = child.Billing_Segment || child.name;

          // Check if this specific billing segment is excluded
          const isExcluded = excludePaths.some(excludePath =>
            excludePath.L1 === masterSegment.id && excludePath.L2 === billingSegmentName
          );
          if (isExcluded) {
            return;
          }
          billingSegments.add(billingSegmentName);
        });
      }

      // Only add to result if there are billing segments after filtering
      if (billingSegments.size > 0) {
        result.push({
          Master_Billing_Segment: masterSegment.id,
          Billing_Segment: Array.from(billingSegments).sort((a, b) => this.compareAlphabetically(a, b)),
          selectedList: Array.from(globalSelectedList)
        });
      }
    });

    this.selectedLobSubLob(result);
  }
  selectedSegment(event) {
    if (!event || !Array.isArray(event) || event.length === 0) {
      return [];
    }
    if(event[0].__selectAll__) {
      return this.setSelectedAllBs(event);
    }
    // Group by L1 (Master_Billing_Segment) and collect L2 values
    const groupedData = new Map<string, Set<string>>();
    const selectedList = new Set<string>();
    event.forEach(item => {
      if (item.L1 && item.L2) {
        selectedList.add(item.L1 + '-' + item.L2);
        if (!groupedData.has(item.L1)) {
          groupedData.set(item.L1, new Set<string>());
        }
        groupedData.get(item.L1).add(item.L2);
      }
    });

    // Transform to the required structure
    const result = Array.from(groupedData.entries()).map(([masterSegment, billingSegments]) => ({
      Master_Billing_Segment: masterSegment,
      Billing_Segment: Array.from(billingSegments).sort((a, b) => this.compareAlphabetically(a, b)),
      selectedList: Array.from(selectedList)
    }));
    this.selectedLobSubLob(result);
  }

  selectedLobSubLob(event) {
    // New simplified logic: just set current selection & recompute derived data
    this.selectedList = event[0] ? [...event[0].selectedList] : [];
    if (event && event.length > 0) {
      this.selectedValues['lob'] = event;
      this.disableReset = false;
      this.filterOwners([], []); // add/remove no longer needed
      this.pruneStaleSelections();
    } else {
      this.selectedValues['lob'] = [];
      this.restoreOriginalFilters();
    }
    if (JSON.stringify(this.searchedSelectedList?.sort() ) !== JSON.stringify(this.selectedList?.sort())) {
      this.enableSearch();
    }
  }

  // Restore original owners/services/apps/segment datasets
  private restoreOriginalFilters() {
    this.ownersData = this.originalFilterist['owners'];
    this.servicesData = this.originalFilterist['services'];
    this.appsData = this.originalFilterist['apps'];
    this.lobSublobListForDropdown = this.originalFilterist['segment'];
  }

  // Removed differentiateSelectionLob: recomputation approach makes incremental diff unnecessary

  filterOwners(add, remove) {
    // Simplified: ignore incremental add/remove deltas and recompute derived lists from current selection
    const selectedSegments: string[] = this.selectedValues.lob.length > 0
      ? this.selectedValues.lob.flatMap(l => l.Billing_Segment as any)
      : [];

    // If no specific sub‑lob selection or full selection, restore originals
    const totalSelectedCount = selectedSegments.length;
    if (totalSelectedCount === 0 || totalSelectedCount === this.totalSegments) {
      this.ownersData = this.originalFilterist['owners'];
      this.servicesData = this.originalFilterist['services'];
      this.appsData = this.originalFilterist['apps'];
      this.lobSublobListForDropdown = this.originalFilterist['segment'];
      return;
    }

    // Candidate apps scoped by selected billing segments
    const candidateApps = (this.filtersData['appDetails'] || []).filter(app => selectedSegments.includes(app.Billing_Segment));

    // Collect owners uniquely
    const ownerMap = new Map<string, any>();
    candidateApps.forEach(app => {
      if (app.SLO_MSID) ownerMap.set(app.SLO_MSID, { id: app.SLO_MSID, name: app.Service_Level_Owner });
      if (app.TechOwner_MSID) ownerMap.set(app.TechOwner_MSID, { id: app.TechOwner_MSID, name: app.Technical_Owner });
      if (app.BusinessOwner_MSID) ownerMap.set(app.BusinessOwner_MSID, { id: app.BusinessOwner_MSID, name: app.Business_Owner });
    });
    this.ownersData = Array.from(ownerMap.values());

    // Delegate to service/app filtering using existing helper
    this.filterServicesBasedOnSelection(candidateApps);
  }

  filterServicesBasedOnSelection(apps) {
    if (!apps || !Array.isArray(apps)) {
      this.selectedValues.services = [];
      return;
    }
    // Sync owner selections with available owners
    this.selectedValues['owner'] = this.selectedValues['owner'].filter(o => this.ownersData.some(r => r.id === o.id));

    const ownerIds = this.selectedValues.owner.map(o => o.id);
    const byService = new Map<string, any>();
    const filteredApps: any[] = [];

    apps.forEach(app => {
      const matchesOwner = ownerIds.length === 0 || ownerIds.some(id => id === app.SLO_MSID || id === app.TechOwner_MSID || id === app.BusinessOwner_MSID);
      if (matchesOwner) {
        if (!byService.has(app.sv_desc)) {
          byService.set(app.sv_desc, { id: app.service, name: app.sv_desc });
        }
        filteredApps.push(app);
      }
    });

    this.servicesData = Array.from(byService.values()).sort((a, b) => this.compareAlphabetically(a?.name, b?.name));
    this.filterAppsBasedOnSelection(filteredApps);
  }

  filterAppsBasedOnSelection(services) {
    if (!services || !Array.isArray(services)) {
      this.appsData = [];
      return;
    }

    // Keep only selected services that remain available
    this.selectedValues['services'] = this.selectedValues['services'].filter(s => this.servicesData.some(r => r.name === s.name));

    const serviceNames = this.selectedValues.services.map(s => s.name);
    const includeAll = serviceNames.length === 0;
    const byApp = new Map<string, any>();

    services.forEach(app => {
      if (includeAll || serviceNames.includes(app.sv_desc)) {
        if (!byApp.has(app.ask_global_id)) {
          byApp.set(app.ask_global_id, {
            id: app.ask_global_id,
            name: app.app_name ? app.ask_global_id + ' ' + app.app_name : app.ask_global_id
          });
        }
      }
    });

    this.appsData = Array.from(byApp.values());
  }
  filterAppsBasedOnSelectionSet(servicesSet: Set<string>, apps) {
    let appsSet = new Set<any>();

    // If servicesSet is empty, return an empty appsSet
    if (servicesSet.size === 0) {
      this.selectedValues['services'] = [];
      return appsSet;
    }

    // If apps is null or undefined, return an empty appsSet
    if (!apps || !Array.isArray(apps)) {
      return appsSet;
    }

    // If selectedValues.services is null, undefined, or empty, return an empty appsSet
    if (!this.selectedValues['services'] || this.selectedValues['services'].length === 0) {
      return appsSet;
    }

    this.selectedValues['services'].forEach(service => {
      if (!servicesSet.has(JSON.stringify(service))) {
        this.selectedValues['services'] = this.selectedValues['services'].filter(row => row.name != service.name);
      }
    });
    if (this.selectedValues['services'].length > 0) {
      apps.forEach(app => {
        if (this.selectedValues.services.findIndex(service => service.name == app.sv_desc) > -1) {
          appsSet.add(
            JSON.stringify({
              id: app.ask_global_id,
              name: app.app_name ? app.ask_global_id + ' ' + app.app_name : app.ask_global_id
            })
          );
        }
      });
    } else {
      apps.forEach(app => {
        appsSet.add(
          JSON.stringify({
            id: app.ask_global_id,
            name: app.app_name ? app.ask_global_id + ' ' + app.app_name : app.ask_global_id
          })
        );
      });
    }
    return appsSet;
  }

  isLeaderOrOwnerSelected = '';

  setSelectedValues(event, type) {
    if (this.clickedChip == '' && (!event || !event.data)) {
      this.enableSearch();
      return; // Exit early if event is null, undefined, or does not have a data property
    }

    if ((type == 'owner' || type == 'leader') && this.clickedChip == 'owners') {
      this.isLeaderOrOwnerSelected = type
      event['type'] = 'Select SLO/BO/TO';
      event['data'] = [{ id: event['id'], name: event['name'] }];
    }

    if (type == 'delegate' && this.clickedChip == 'delegate') {
      event['type'] = 'delegate';
      event['data'] = [{ id: event['id'], name: event['name'] }];
    }

    event['data'] = event['data'] || [];
    if ((type == 'owner' || type == 'leader') && this.clickedChip == 'owners') {
      this.handleOwnerOrDelegateSelection(event, true);
    }
    if (type == 'delegate' && this.clickedChip == 'delegate') {
      this.handleOwnerOrDelegateSelection(event, false);
    }
    else if (event['type'] == 'Select Service') {
      this.disableReset = false;
      this.selectedValues['services'] = event['data'];
      const promise = new Promise((resolve) => {
        if (
          this.selectedValues['owner'].length == 0 &&
          this.selectedValues['lob'].length == 0 &&
          this.selectedValues['services'].length == 0
        ) {
          this.appsData = this.originalFilterist['apps'];
        } else {
          const appsSet = this.filterApps();
          this.appsData = [...appsSet].map(app => JSON.parse(app));
        }
        resolve(null);
      });
      promise.then(() => {
        this.selectedValues['apps'].forEach(app => {
          if (this.appsData.findIndex(row => row.id == app.id) < 0) {
            this.selectedValues['apps'] = this.selectedValues['apps'].filter(row => row.id != app.id);
          }
        });
      });
    }
    else if (event['type'] == 'Select Application') {
      this.disableReset = false;
      this.selectedValues['apps'] = event['data'];
    }
    else if (event['type'] == 'Select App Lifecycle Status') {
      this.selectedValues['lifecycle'] = event['data'];
      this.disableSearch = false;
    }
    this.enableSearch();
  }

  // Consolidated logic for owner or delegate selection updates
  private handleOwnerOrDelegateSelection(event: any, isOwnerChip: boolean) {
    this.servicesData = [];
    this.disableReset = false;
    this.showLeaderList = false;
    this.leaderSearch = event['name'];
    this.selectedValues['owner'] = event['data'];

    const promise = new Promise((resolve) => {
      if (this.selectedValues['owner'].length === 0 && this.selectedValues['lob'].length === 0) {
        this.appsData = this.originalFilterist['apps'];
        this.servicesData = this.originalFilterist['services'];
      } else {
        const { servicesSet, appsSet } = this.filterServices();
        this.servicesData = [...servicesSet].map(service => JSON.parse(service));
        this.appsData = [...appsSet].map(app => JSON.parse(app));
        this.servicesData = this.removeDuplicateServices(this.servicesData);
      }
      this.servicesData = this.sortServiceData();
      resolve(null);
    });

    promise.then(() => {
      this.pruneStaleSelections();
    });
  }

  // Remove duplicate services by name
  private removeDuplicateServices(services: any[]): any[] {
    const seen = new Set<string>();
    return services.filter(s => {
      if (!s || !s.name) return false;
      if (seen.has(s.name)) return false;
      seen.add(s.name);
      return true;
    });
  }

  // Prune services/apps that are no longer available after filtering
  private pruneStaleSelections() {
    if (isArray(this.selectedValues['services'])) {
      this.selectedValues['services'] = this.selectedValues['services'].filter(service =>
        this.servicesData.findIndex(row => row.name === service.name) > -1
      );
    }
    if (isArray(this.selectedValues['apps'])) {
      this.selectedValues['apps'] = this.selectedValues['apps'].filter(app =>
        this.appsData.findIndex(row => row.id === app.id) > -1
      );
    }
  }

  filterServices() {
    this.servicesData = [];
    const servicesSet = new Set<string>();

    // Determine candidate apps based on selected LOBs (if any)
    const selectedLobs: string[] = this.selectedValues.lob.length > 0
      ? this.selectedValues.lob.flatMap(l => l.Billing_Segment as any)
      : [];
    let candidateApps = this.filtersData['appDetails'] || [];
    if (selectedLobs.length > 0) {
      candidateApps = candidateApps.filter(app => selectedLobs.includes(app.Billing_Segment));
    }

    // Filter by owners or delegates when applicable
    if (this.selectedValues.owner.length > 0) {
      if (this.clickedChip === 'delegate') {
        candidateApps = candidateApps.filter(app => this.selectedValues.owner.some(o => o.id == app.Delegates_MSID));
      } else if (this.clickedChip === 'owners') {
        candidateApps = candidateApps.filter(app => this.matchesSelectedOwner(app));
      }
    }

    // Build servicesSet & filteredApps list
    const filteredApps: any[] = [];
    candidateApps.forEach(app => {
      servicesSet.add(JSON.stringify({ id: app.service, name: app.sv_desc }));
      filteredApps.push(app);
    });

    return { servicesSet, appsSet: this.filterAppsBasedOnSelectionSet(servicesSet, filteredApps) };
  }

  filterApps(onSelection : boolean = false) {
    this.appsData = [];
    const appsSet = new Set<string>();

    // Gather selected lob segments
    let selectedLobs: string[] = [];
    const lobSelection = this.selectedValues.lob || [];
    selectedLobs = lobSelection.flatMap(item => typeof item == 'string' ? this.updateBillingSegmentFilter(item) : item.Billing_Segment);

    // Base candidate apps (by lob if provided)
    let candidateApps = this.filtersData['appDetails'] || [];
    if (selectedLobs.length > 0) {
      candidateApps = candidateApps.filter(app => selectedLobs.includes(app.Billing_Segment));
    }

    // Owner / delegate filtering
    if (this.selectedValues.owner.length > 0) {
      if (this.clickedChip === 'delegate') {
        candidateApps = candidateApps.filter(app => this.selectedValues.owner.some(o => o.id == app.Delegates_MSID));
      } else if (this.clickedChip === 'owners') {
        candidateApps = candidateApps.filter(app => this.matchesSelectedOwner(app));
      }
    }

    // Service filtering (if services chosen)
    if (this.selectedValues.services.length > 0) {
      candidateApps = candidateApps.filter(app => this.selectedValues.services.some(s => s.name === app.sv_desc));
    }

    // Build appsSet
    candidateApps.forEach(app => {
      appsSet.add(JSON.stringify({
        id: app.ask_global_id,
        name: app.app_name ? app.ask_global_id + ' ' + app.app_name : app.ask_global_id
      }));
    });

    return appsSet;
  }

  search() {
    this.SearchLength = 1;
    this.showAddNewAppButton = false;
    const { payload, queryParams } = this.buildUnifiedSearchArtifacts();
    this.searchedSelectedList = queryParams['selectedList'] ? JSON.parse(queryParams['selectedList']) : [];
    this.getForecastDetailsAPI(payload);
    this.updateLocation(queryParams); // reuse existing method for URL
  }

  // Helper predicate: does an app match any selected owner MSID (includes extended levels)
  private matchesSelectedOwner(app: any): boolean {
    if (!app || !this.selectedValues.owner || this.selectedValues.owner.length === 0) return false;
    const ownerIds = this.selectedValues.owner.map(o => o.id);
    return ALL_OWNER_KEYS.some(key => ownerIds.includes(app[key]));
  }


  // Unified builder reducing duplication between payload and query param construction
  private buildUnifiedSearchArtifacts() {
    const payload: any = {};
    const queryParams: any = {};

    const lobSelection = this.selectedValues.lob || [];
    const ownerSelection = this.selectedValues.owner || [];
    const lifecycleSelection = this.selectedValues.lifecycle || [];
    const serviceSelection = this.selectedValues.services || [];
    const appSelection = this.selectedValues.apps || [];

    if (lobSelection.length > 0) {
      const billingSegments = lobSelection.flatMap(item => typeof item == 'string' ? this.updateBillingSegmentFilter(item) : item.Billing_Segment);
      payload['Billing_Segment'] = billingSegments;
      queryParams['selectedList'] = JSON.stringify(this.selectedList);
      queryParams['Billing_Segment'] = JSON.stringify(billingSegments.map(name => encodeURIComponent(name)));
    }

    if (this.clickedChip === 'delegate' && ownerSelection.length > 0) {
      const ids = ownerSelection.map(o => o.id);
      payload['delegateId'] = ids;
      queryParams['delegateId'] = JSON.stringify(ids);
    }

    if (this.clickedChip === 'owners' && ownerSelection.length > 0) {
      const ids = ownerSelection.map(o => o.id);
      const prefix = this.isLeaderOrOwnerSelected === 'leader' ? 'leader' : 'owner';
      this.selectedOwnerType.forEach(type => {
        const dynamicKey = `${prefix}${type}Id`;
        payload[dynamicKey] = ids;
        queryParams[dynamicKey] = JSON.stringify(ids);
      });
    }

    if (lifecycleSelection.length !== this.lifeCycleData.length) {
      const names = lifecycleSelection.map(l => l.name);
      payload['App Lifecycle_Status'] = names;
      queryParams['App Lifecycle_Status'] = JSON.stringify(names);
    }

    if (serviceSelection.length > 0 && serviceSelection.length !== this.servicesData.length) {
      const names = serviceSelection.map(s => s.name);
      payload['sv_desc'] = names;
      queryParams['sv_desc'] = JSON.stringify(names);
    }

    if (appSelection.length > 0 && appSelection.length !== this.appsData.length) {
      const ids = appSelection.map(a => a.id);
      payload['ask_global_id'] = ids;
      queryParams['ask_global_id'] = JSON.stringify(ids.map(id => encodeURIComponent(id)));
    }

    return { payload, queryParams };
  }

  updateBillingSegmentFilter(item:string): string {
    if(!item) return '';
    let arr = item.split('-');
    //Remove the first index and return rest
    if(arr.length > 1)
      arr.shift();
    return arr.join('-');
  }

  updateLocation(queryParams) {
    if (Object.keys(queryParams).length === 0) {
      queryParams = { selectAll: 1 };
    }

    queryParams['selectedTab'] = this.clickedChip;
    if (this.clickedChip === 'owners' || this.clickedChip === 'delegate') {
      queryParams['leaderSearch'] = this.leaderSearch;
      if (this.clickedChip === 'owners') {
        queryParams['selectedOwnerType'] = JSON.stringify(this.selectedOwnerType);
      }
    }

     this.disableSearch = true;
     this.disableReset = false;

     // Explicitly encode the entire filters string to ensure special characters like & are properly encoded
     const filters = JSON.stringify(queryParams);
     const encodedFilters = encodeURIComponent(filters);
     this.route.navigate(['/maintenanceV4/forecast-management/search'], {
       queryParams: { filters: encodedFilters },
       queryParamsHandling: 'merge'
     });
  }

  reset() {
    this.disableReset = true;
    this.disableSearch = true;
    this.showAddNewAppButton = true;
    this.showLeaderList = false;
    this.leaderSearch = '';
    this.searchedSelectedList = [];
    this.isLeaderOrOwnerSelected = '';
    this.selectedValues = {
      lob: [],
      owner: [],
      lifecycle: this.lifeCycleData,
      services: [],
      apps: []
    };
    this.initialSelectedLob = [];
    this.ownersData = this.originalFilterist['owners'];
    this.servicesData = this.originalFilterist['services'];
    this.appsData = this.originalFilterist['apps'];
    this.lobSublobListForDropdown = this.originalFilterist['segment'];
    this.dataSourceDetails = new MatTableDataSource([]);
    this.SearchLength = 0;
    this.isForecastTableDataLoaded = false;
    this.forecastTableData = [];
    this.initialSelectedLobString = '';
    this.resetTrigger = this.resetTrigger + 1;
    this.location.go('maintenanceV4/forecast-management');
  }
  enableSearch() {
    if (
      this.selectedValues['lob'].length > 0 ||
      this.selectedValues['owner'].length > 0 ||
      this.selectedValues['services'].length > 0 ||
      this.selectedValues['apps'].length > 0
    ) {
      this.disableSearch = false;
    }
  }

  info() {
    window.open(environment.docUrl + 'user-guide/Forecast-Management/', '_blank');
  }

  navigateToServicePage() {
    this.route.navigate(['/maintenanceV4/forecast-service']);
  }
  frameProperCase(name: string): string {
    if (!name || typeof name !== 'string') {
      return '';
    }
    return name
      .split(/(\s+|-)/) // Split by spaces or hyphens while keeping the delimiters
      .map(w => (w && !/(\s+|-)/.test(w) ? w[0].toUpperCase() + w.substring(1).toLowerCase() : w))
      .join('');
  }

  onToggleChange(value) {
    if (value) this.expanded_columns = this.expanded_columns_charge;
    else this.expanded_columns = this.expanded_columns_vol;
  }
  getServiceAndAccessDetails(isRefresh: boolean = false) {
    this.maintenanceService.getServicesList().subscribe(data => {

      // Set masterServicesData to undefined if the response is undefined
      if (data === undefined) {
        this.masterServicesData = undefined;
        return;
      }
      // Check if data is null or undefined
      if (!data) {
        console.warn('Service response is null or does not contain forecastData.');
        this.masterServicesData = null;
        return;
      }
      this.masterServicesData = data;
      if (this.masterServicesData.forecastData) {
        this.masterServicesData.forecastData.forEach(element => {
          if (element.Previous.toLowerCase() == 'no') {
            this.forecastDetailsMap.set('currentForecastCycle', element.Forecast_Cycle);
            this.forecastDetailsMap.set('currentYear_prev_no', (element.Forecast_Year).toString());
            this.forecastDetailsMap.set('previousYear_prev_no', (element.Forecast_Year - 1).toString());
            this.forecastDetailsMap.set('nextYear_prev_no', (element.Forecast_Year + 1).toString());
            if (isRefresh) {
              this.getForeCastCycleType(element)
            }
          } else {
            this.forecastDetailsMap.set('previousForecastCycle', element.Forecast_Cycle);
          }
          this.forecastMapChanges.next(++this.initialCount);
        });
      }
    });
  }

  setTableColumn() {
    this.TABLE_COLUMNS = [
      {
        key: 'app_name',
        labelKey: 'app_name',
        label: 'Application Name',
        width: '18% !important',
        padding: '0.2rem !important',
        link: true,
        align: 'left !important',
        paddingLeft: true
      },
      {
        key: 'Billing_Segment',
        width: '14% !important',
        label: 'Billing Segment',
        padding: '0.2rem !important',
        align: 'left !important',
        paddingLeft: true
      },
      {
        key: 'decom_date',
        width: '12% !important',
        label: 'Decom Validation Date',
        padding: '0.2rem !important',
        align: 'center !important'
      },
      {
        key: 'Prev_FY_Total',
        labelKey: 'PY_Rate',
        label: this.forecastDetailsMap.get('previousYear_prev_no') + ' FY',
        width: '10% !important',
        padding: '0.2rem !important',
        align: 'center !important',
        currency: true,
        color: '#666261'
      },
      {
        key: 'Current_Projections_Total',
        label: this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections',
        width: '10% !important',
        padding: '0.2rem !important',
        align: 'center !important',
        currency: true,
        color: '#652A89'
      },
      {
        key: 'Curr_Year_FC_Prev_Charges_Total',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '8% !important',
        align: 'center !important',
        padding: '0.2rem !important',
        currency: true,
        color: '#F37F58'
      },
      {
        key: 'Curr_Year_FC_Curr_Charges_Total',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('currentForecastCycle') +
          ')',
        width: '8% !important',
        align: 'center !important',
        padding: '0.2rem !important',
        currency: true,
        color: '#099AA9'
      },
      {
        key: 'Future_Year_FC_Prev_Charges_Total',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '8% !important',
        align: 'center !important',
        padding: '0.2rem !important',
        currency: true,
        color: '#F37F58'
      },
      {
        key: 'Future_Year_FC_Curr_Charges_Total',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') + ' FC (' + this.forecastDetailsMap.get('currentForecastCycle') + ')',
        width: '8% !important',
        align: 'center !important',
        padding: '0.2rem !important',
        currency: true,
        color: '#007C89'
      },
      {
        key: 'Actions',
        label: 'Action',
        width: '4% !important',
        align: 'center !important',
        padding: '0.2rem !important'
      }
    ];
    this.expanded_columns_charge = [
      {
        key: 'sv_desc',
        labelKey: 'sv_desc',
        label: 'Service Name',
        width: '18% !important',
        padding: '0.2rem !important',
        textAlign: 'left !important',
        paddingLeft: true
      },
      {
        key: 'PY_Rate',
        labelKey: 'PY_Rate',
        label: this.forecastDetailsMap.get('previousYear_prev_no'),
        width: '6% !important',
        textAlign: 'center !important',
        isRowSpan: false,
        isUnitOfMeasure: true,
        padding: '0.2rem !important'
      },
      {
        key: 'CY_Rate',
        label: this.forecastDetailsMap.get('currentYear_prev_no'),
        width: '6% !important',
        textAlign: 'center !important',
        isRowSpan: false,
        isUnitOfMeasure: true,
        padding: '0.2rem !important'
      },
      {
        key: 'Future_Year_Rate',
        label: this.forecastDetailsMap.get('nextYear_prev_no'),
        width: '6% !important',
        textAlign: 'center !important',
        isRowSpan: false,
        isUnitOfMeasure: true,
        padding: '0.2rem !important'
      },
      {
        key: 'Prev_Year_FY_Charges',
        labelKey: 'Prev_Year_FY_Charges',
        label: this.forecastDetailsMap.get('previousYear_prev_no') + ' FY',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        color: '#666261',
        padding: '0.2rem !important'
      },
      {
        key: 'Infra_projected_Charges',
        labelKey: 'Infra_projected_Charges',
        label: this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        color: '#652A89',
        padding: '0.2rem !important'
      },
      {
        key: 'Curr_Year_FC_Prev_Charges',
        labelKey: 'Curr_Year_FC_Prev_Charges',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        color: '#F37F58',
        isRowSpan: true,
        padding: '0.2rem !important'
      },
      {
        key: 'Curr_Year_FC_Curr_Charges',
        labelKey: 'Curr_Year_FC_Curr_Charges',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('currentForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        color: '#099AA9',
        isRowSpan: true,
        padding: '0.2rem !important'
      },
      {
        key: 'Future_Year_FC_Prev_Charges',
        labelKey: 'Future_Year_FC_Prev_Charges',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        isRowSpan: true,
        color: '#F37F58',
        padding: '0.2rem !important'
      },
      {
        key: 'Future_Year_FC_Curr_Charges',
        labelKey: 'Future_Year_FC_Curr_Charges',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') + ' FC (' + this.forecastDetailsMap.get('currentForecastCycle') + ')',
        width: '10% !important',
        textAlign: 'center !important',
        currency: true,
        isRowSpan: true,
        color: '#007C89',
        padding: '0.2rem !important',
        noBorder: true
      },
      {
        key: 'Action',
        labelKey: 'Action',
        label: 'Action',
        width: '4% !important',
        textAlign: 'center !important',
        padding: '0.2rem !important'
      }
    ];
    this.expanded_columns_vol = [
      {
        key: 'sv_desc',
        labelKey: 'sv_desc',
        label: 'Service Name',
        width: '18% !important',
        padding: '0.2rem !important',
        textAlign: 'left !important',
        paddingLeft: true
      },
      {
        key: 'PY_Rate',
        labelKey: 'PY_Rate',
        label: this.forecastDetailsMap.get('previousYear_prev_no'),
        width: '6% !important',
        isUnitOfMeasure: true,
        textAlign: 'center !important',
        padding: '0.2rem !important'
      },
      {
        key: 'CY_Rate',
        label: this.forecastDetailsMap.get('currentYear_prev_no'),
        width: '6% !important',
        isUnitOfMeasure: true,
        textAlign: 'center !important',
        padding: '0.2rem !important'
      },
      {
        key: 'Future_Year_Rate',
        label: this.forecastDetailsMap.get('nextYear_prev_no'),
        isUnitOfMeasure: true,
        width: '6% !important',
        textAlign: 'center !important',
        padding: '0.2rem !important'
      },
      {
        key: 'Prev_Year_FY_Volume',
        labelKey: 'Prev_Year_FY_Volume',
        label: this.forecastDetailsMap.get('previousYear_prev_no') + ' FY',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#666261',
        padding: '0.2rem !important',
        volume: true
      },
      {
        key: 'Infra_projected_Volumes',
        labelKey: 'Infra_projected_Volumes',
        label: this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#652A89',
        padding: '0.2rem !important',
        volume: true
      },
      {
        key: 'Curr_Year_FC_Prev_Volume',
        labelKey: 'Curr_Year_FC_Prev_Volume',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#F37F58',
        padding: '0.2rem !important',
        volume: true
      },
      {
        key: 'Curr_Year_FC_Curr_Volume',
        labelKey: 'Curr_Year_FC_Curr_Volume',
        label:
          this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('currentForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#099AA9',
        padding: '0.2rem !important',
        volume: true
      },
      {
        key: 'Future_Year_FC_Prev_Volume',
        labelKey: 'Future_Year_FC_Prev_Volume',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#F37F58',
        padding: '0.2rem !important',
        volume: true
      },
      {
        key: 'Future_Year_FC_Curr_Volume',
        labelKey: 'Future_Year_FC_Curr_Volume',
        label:
          this.forecastDetailsMap.get('nextYear_prev_no') + ' FC (' + this.forecastDetailsMap.get('currentForecastCycle') + ')',
        width: '10% !important',
        textAlign: 'center !important',
        color: '#007C89',
        padding: '0.2rem !important',
        volume: true,
        noBorder: true
      },
      {
        key: 'Action',
        labelKey: 'Action',
        label: 'Action',
        width: '4% !important',
        textAlign: 'center !important',
        padding: '0.2rem !important'
      }
    ];
    this.onToggleChange(true);
  }

  determineRoles() {
    //SRM_Viewer
    this.segmentAdmin =  [...new Set([...this.sharedAuthService.getForecastAccessDetails('SRM') ,...this.sharedAuthService.getForecastAccessDetails('')])];
    this.segment_SRM_Viewer = this.sharedAuthService.getForecastAccessDetails('SRM_Viewer');
    this.isAdminOrViewer = this.sharedAuthService.isFCAdminorAdminViewer();
      this.isSegmentFAOrViewer = this.sharedAuthService.isFCSRMorSRMViewer();
      (this.isAdminOrViewer || this.isSegmentFAOrViewer )? this.lifeCycleData.push({ id: 4, name: 'NON AIDE Specific' }): this.lifeCycleData.filter((item: any) => item['id'] != 4);
  }

  getForecastOwnerDetails() {
    this.isForecastTableUpdated = false;
    let resultAppOwner:any = [];
    resultAppOwner = this.sharedAuthService.getForecastAccessDetails('AppOwner');
    const adminRole = this.sharedAuthService.isForecastAdmin();
    const srmRole = this.sharedAuthService.getForecastAccessDetails('SRM');
    this.determineRoles();
    if (adminRole.length > 0) {
      this.isForecastAdmin = true;
    }

    if (srmRole.length > 0) {
      this.isForecastSRM = true;
    }
    // condition to show "Add New Application Button"
    if(adminRole.length > 0 || srmRole.length > 0 || resultAppOwner.length >0)
    {
      this.showAddNewAppButtonByRole = true;
    }
    if (this.isForecastAdmin) {
      this.tabs = [
        { label: 'Forecast Management', value: 'forecast_management' },
        { label: 'Segment Relationship Manager', value: 'segment_relationship' },
        { label: 'Admin Dashboard', value: 'master_table_management' },
        { label: 'Bulk Forecast', value: 'bulk_forecast' },
      ];
    }
    this.forecastMapChanges.next(++this.initialCount);
    this.getForecastDetails();
  }

  navigateToTeams() {
    const url = "https://teams.microsoft.com/l/channel/19%3A04d331c020844c8195d3b5367c69a144%40thread.tacv2/TechOps%20Hub%20Infra%20Forecast%20Management?groupId=2ddaff3a-b209-451a-8405-5c0530c43e91&tenantId=db05faca-c82a-4b9d-b9c5-0f64b6755421";
    window.open(url, '_blank');
  }

  //Function to sort data based on Master_Billing_Segment (None and No Mapping should be at the end)
  sortSegmentData(arr) {
    if (!arr || !Array.isArray(arr)) {
      return [];
    }
    return arr.sort((a, b) => {
      const valueA = a.Master_Billing_Segment.toLowerCase();
      const valueB = b.Master_Billing_Segment.toLowerCase();
      if (valueA === 'none' || valueA === 'no mapping') {
        return 1;
      }
      if (valueB === 'none' || valueB === 'no mapping') {
        return -1;
      }
      return this.compareAlphabetically(valueA, valueB);
    });
  }

  //Sort Service Data in dropdown
  sortServiceData() {
    if (this.servicesData && this.servicesData.length > 0) {
      return this.servicesData.sort((a, b) => this.compareAlphabetically(a?.name, b?.name));
    }
    return [];
  }

  /**
   * @author Raghavendra Prasad
   * Add New Application functions
   */

  addNewApplicationService() {
    this.addServicePopup.show();
  }

  getNewApplication() {
    const payload = { role: 'Admin' };
    this.maintenanceService.getNewApplication(payload).subscribe({
      next: response => {
        this.allNewApps = response;
      },
      error: error => {
        console.error('Error fetching data:', error);
      }
    });
  }

  refreshServicesForApp() {
    this.getNewApplication();
    this.getForecastFilters();
    this.addServicePopup.hide();
  }

  navigateToWatchDemo() {
    const hostname = window.location.origin;
    const path = '/video-library'
    const url = hostname + path + '?category=Forecast Management';
    window.open(url, '_blank');
  }

  formatDate(dateString: string) : string{
    const [year, month, day] = dateString.split('-');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
  }

  getCentralDate(): string {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  }

  //Add logic for determining the cycle type based on the dates
  //Offcycle: if currentdate is between startDate and emailStartDate (include start date)
  //Incycle: if currentdate is between emailStartDate and endDate  (include emailStartDate)
  //ClosedCycle: if currentdate is beyond endDate
  //calculate based on central timezone
  getForeCastCycleType(forecastCycleData) {
    this.forecastCycleType = null
    const centralCurrentDate = this.getCentralDate();
    const centralZoneStartDate = forecastCycleData.Start_Date ? forecastCycleData.Start_Date : null;
    const centralZoneEmailStartDate = forecastCycleData.Email_Start_Date ? forecastCycleData.Email_Start_Date : null;
    const centralZoneEndDate = forecastCycleData.End_date ? forecastCycleData.End_date : null;
    const centralZoneAdminEndDate = forecastCycleData.Admin_End_Date ? forecastCycleData.Admin_End_Date : null;
    const forecastYear = forecastCycleData.Forecast_Year ? forecastCycleData.Forecast_Year : '';
    const forecastCycle = forecastCycleData.Forecast_Cycle ? forecastCycleData.Forecast_Cycle : '';

    if(this.isForecastAdmin || this.isForecastSRM)
    {

       if (centralZoneStartDate && centralZoneEmailStartDate && centralCurrentDate >= centralZoneStartDate && centralCurrentDate < centralZoneEmailStartDate) {
          this.forecastCycleType = { type: 'Off-cycle', msg: 'Forecast tool is now open for updates.',submsg:' Communication for the '+ forecastYear + ' ' + forecastCycle + ' Forecast will be coming soon. Re-attestation will be required'}
          }
          else if (centralZoneEmailStartDate && centralZoneAdminEndDate && centralCurrentDate >= centralZoneEmailStartDate && centralCurrentDate <= centralZoneAdminEndDate) {

            const countDown = this.getCountDownDays(centralZoneEndDate, centralZoneAdminEndDate);
            const dayTxt = countDown > 1 ? 'days' : 'day';
            this.forecastCycleType = { type: 'In-cycle', msg: forecastYear + ' ' + forecastCycle + " Forecast is now open for attestations.", submsg: countDown +  ' '+ dayTxt +' remaining!' };
          }
          // else if (centralZoneEndDate && centralCurrentDate > centralZoneEndDate) { // removing else if condition to make it closed cycle if it does not fall in off-cycle and in-cycle
          else{
            this.forecastCycleType = { type: 'Closed-cycle', msg: 'Forecast Cycle is now closed for updates.', submsg: 'You will be notified when the portal reopens.' };
          }

    }
    else {

         if (centralZoneStartDate && centralZoneEmailStartDate && centralCurrentDate >= centralZoneStartDate && centralCurrentDate < centralZoneEmailStartDate) {
          this.forecastCycleType = { type: 'Off-cycle', msg: 'Forecast tool is now open for updates.',submsg:' Communication for the '+ forecastYear + ' ' + forecastCycle + ' Forecast will be coming soon. Re-attestation will be required'}
          }
          else if (centralZoneEmailStartDate && centralZoneEndDate && centralCurrentDate >= centralZoneEmailStartDate && centralCurrentDate <= centralZoneEndDate) {
            const countDown = this.getCountDownDays(centralZoneEndDate, centralZoneAdminEndDate);
            const dayTxt = countDown > 1 ? 'days' : 'day';
            this.forecastCycleType = { type: 'In-cycle', msg: forecastYear + ' ' + forecastCycle + " Forecast is now open for attestations.", submsg: countDown +  ' '+ dayTxt +' remaining!' };
          }
          // else if (centralZoneEndDate && centralCurrentDate > centralZoneEndDate) { // removing else if condition to make it closed cycle if it does not fall in off-cycle and in-cycle
          else{
            this.forecastCycleType = { type: 'Closed-cycle', msg: 'Forecast Cycle is now closed for updates.', submsg: 'You will be notified when the portal reopens.' };
          }

    }


    this.updateStepper();
  }

  //Function to get the countdown days based on endDate and adminEndDate include both the dates
  getCountDownDays(endDate, adminEndDate) {
    if (this.isForecastAdmin || this.isForecastSRM) {
      // For Admin and SRM, use adminEndDate - currentDate
      if (!adminEndDate) return null;
      return this.daysRemaining(adminEndDate); // Including the end date
    }else {
      // For others, use endDate - currentDate
      if (!endDate) return null;
      return this.daysRemaining(endDate); // Including the end date
    }
  }

  daysRemaining(date: string | Date) {
    const currentDate = this.getCentralDate();
    const [ty, tm, td] = currentDate.split('-').map(Number);
    const today = new Date(ty, tm - 1, td);

    let endDate: Date;
    if (typeof date === 'string') {
      const [fy, fm, fd] = date.split('-').map(Number);
      endDate = new Date(fy, fm - 1, fd);
    } else {
      endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    const timeDiff = endDate.getTime() - today.getTime();
    const daysDiff = Math.abs(Math.ceil(timeDiff / (1000 * 60 * 60 * 24)));
    return daysDiff + 1; // Including both the current day and the end date
  }

  updateStepper() {
    const cycle = this.forecastCycleType ? this.forecastCycleType.type : null;
    if (cycle) {
      if (cycle == 'Off-cycle') {
        this.steps[0].status = 'current';
        this.steps[1].status = 'pending';
        this.steps[2].status = 'pending';
        this.steps[0].pillText = 'In Progress';
        this.steps[1].pillText = 'Pending';
        this.steps[2].pillText = 'Pending';
      } else if (cycle == 'In-cycle') {
        this.steps[0].status = 'done';
        this.steps[1].status = 'current';
        this.steps[2].status = 'pending';
        this.steps[0].pillText = 'Completed';
        this.steps[1].pillText = 'In Progress';
        this.steps[2].pillText = 'Pending';
      } else if (cycle == 'Closed-cycle') {
        this.steps[0].status = 'done';
        this.steps[1].status = 'done';
        this.steps[2].status = 'current';
        this.steps[0].pillText = 'Completed';
        this.steps[1].pillText = 'Completed';
        this.steps[2].pillText = 'In Progress';
      }
    }
  }

  refreshData() {
    this.getServiceAndAccessDetails(true);
    this.getForecastDetails();
    this.maintenanceService.deleteCachedData('isAdminDashboardUpdated');
  }

  getMSIDFromDataItem(name, item, searchType) {
    let key = Object.keys(item).find(key => item[key] === name);

    const leaderKeys = [
      'BusinessOwner_L4_Name',
      'BusinessOwner_L5_Name',
      'BusinessOwner_L6_Name',
      'BusinessOwner_L7_Name',
      'BusinessOwner_L8_Name',
      'SLO_L4_Name',
      'SLO_L5_Name',
      'SLO_L6_Name',
      'SLO_L7_Name',
      'SLO_L8_Name',
      'TechOwner_L4_Name',
      'TechOwner_L5_Name',
      'TechOwner_L6_Name',
      'TechOwner_L7_Name',
      'TechOwner_L8_Name'
    ];

    const ownerKeyMaPPING = {
      'BusinessOwner_L4_Name': 'BO_L4_MSID',
      'BusinessOwner_L5_Name': 'BO_L5_MSID',
      'BusinessOwner_L6_Name': 'BO_L6_MSID',
      'BusinessOwner_L7_Name': 'BO_L7_MSID',
      'BusinessOwner_L8_Name': 'BO_L8_MSID',
      'SLO_L4_Name': 'SLO_L4_MSID',
      'SLO_L5_Name': 'SLO_L5_MSID',
      'SLO_L6_Name': 'SLO_L6_MSID',
      'SLO_L7_Name': 'SLO_L7_MSID',
      'SLO_L8_Name': 'SLO_L8_MSID',
      'TechOwner_L4_Name': 'TO_L4_MSID',
      'TechOwner_L5_Name': 'TO_L5_MSID',
      'TechOwner_L6_Name': 'TO_L6_MSID',
      'TechOwner_L7_Name': 'TO_L7_MSID',
      'TechOwner_L8_Name': 'TO_L8_MSID'
    }

    switch (searchType) {
      case 'Technical_Owner':
        return item.TechOwner_MSID;
      case 'Service_Level_Owner':
        return item.SLO_MSID;
      case 'Business_Owner':
        return item.BusinessOwner_MSID;
      default:
        if (leaderKeys.includes(key)) {
          return item[ownerKeyMaPPING[key]];
        }
        break;
    }
  }

}
